import { render } from "./JFmanual.vue?vue&type=template&id=71a71266&scoped=true"
import script from "./JFmanual.vue?vue&type=script&lang=js"
export * from "./JFmanual.vue?vue&type=script&lang=js"

import "./JFmanual.vue?vue&type=style&index=0&id=71a71266&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a71266"]])

export default __exports__